import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import styled from '@emotion/styled';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import Link from '@material-ui/core/Link';
import Menu from '@material-ui/core/Menu';
import CheckIcon from '@material-ui/icons/FileDownload';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  text-decoration: none;\n  font-weight: 400;\n  line-height: 1.428571429;\n  color: #333333;\n  white-space: nowrap;\n  &:hover {\n    text-decoration: none;\n    color: #333333;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledLink = styled(Link)(_templateObject());

var Timesheet = function Timesheet(_ref) {
  var handleRealTime = _ref.handleRealTime,
      handleTimesheet = _ref.handleTimesheet;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var open = Boolean(anchorEl);

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClick,
    color: "secondary",
    variant: "outlined",
    sx: {
      textTransform: 'Capitalize'
    },
    startIcon: /*#__PURE__*/React.createElement(CheckIcon, null)
  }, "Timesheet"), /*#__PURE__*/React.createElement(Menu, {
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    onClick: handleClose,
    getContentAnchorEl: null,
    PaperProps: {
      sx: {
        marginTop: 1,
        border: '1px solid rgba(0, 0, 0, 0.15)',
        borderRadius: '4px'
      }
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React.createElement(MenuItem, null, /*#__PURE__*/React.createElement(StyledLink, {
    href: handleRealTime,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Realtime Timesheet")), /*#__PURE__*/React.createElement(MenuItem, null, /*#__PURE__*/React.createElement(StyledLink, {
    href: handleTimesheet
  }, "Download"))));
};

var AcceptedOrder = function AcceptedOrder(_ref2) {
  var handleView = _ref2.handleView,
      handleStaffView = _ref2.handleStaffView,
      handleTimesheet = _ref2.handleTimesheet,
      handleRealTime = _ref2.handleRealTime,
      ShiftCounter = _ref2.ShiftCounter,
      more = _ref2.more;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleStaffView,
    variant: "outlined",
    color: "secondary"
  }, ShiftCounter)), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleView,
    variant: "outlined",
    color: "secondary",
    sx: {
      textTransform: 'Capitalize'
    }
  }, "View Details")), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Timesheet, {
    handleTimesheet: handleTimesheet,
    handleRealTime: handleRealTime
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, more));
};

export { AcceptedOrder };